import { render, staticRenderFns } from "./quick-play-panel.vue?vue&type=template&id=58347cae&scoped=true"
import script from "./quick-play-panel.vue?vue&type=script&lang=js"
export * from "./quick-play-panel.vue?vue&type=script&lang=js"
import style0 from "./quick-play-panel.vue?vue&type=style&index=0&id=58347cae&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58347cae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58347cae')) {
      api.createRecord('58347cae', component.options)
    } else {
      api.reload('58347cae', component.options)
    }
    module.hot.accept("./quick-play-panel.vue?vue&type=template&id=58347cae&scoped=true", function () {
      api.rerender('58347cae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/desktop/quick-play-panel.vue"
export default component.exports